"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var arrow_1 = require("../icons/arrow");
var inputWrapper_1 = require("../inputWrapper");
var functions_1 = require("../../utils/functions");
var text_1 = require("../base/text");
var clickOutside_1 = require("../clickOutside");
var form_1 = require("../form");
exports.Selectbox = React.memo(function (_a) {
    var options = _a.options, name = _a.name, type = _a.type, onlyChildren = _a.onlyChildren, message = _a.message, _b = _a.defaultOption, defaultOption = _b === void 0 ? null : _b, _c = _a.passive, passive = _c === void 0 ? false : _c, _d = _a.scroll, scroll = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "small" /* Small */ : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.placeholder, placeholder = _g === void 0 ? '' : _g, _h = _a.onSelect, onSelect = _h === void 0 ? functions_1.NOOP : _h;
    var _j;
    var _k = React.useState(false), showOptions = _k[0], toggleShowOptions = _k[1];
    var _l = form_1.useForm(defaultOption, name, type, message), selectedOption = _l[0], setSelectedOption = _l[1], _type = _l[2], _message = _l[3];
    var clickRef = React.useRef(false);
    var optionsRef = React.useRef({});
    var selectboxClassName = classnames_1.default('ty-input', 'ty-select', 'ty-bordered', 'ty-transition', "ty-input-" + size, {
        'ty-bordered-focus': showOptions,
    });
    var optionsWrapperClassName = classnames_1.default('ty-select-options', 'ty-scrollbar', 'ty-bordered-focus', { 'ty-on': showOptions });
    var onOptionClick = function (option) {
        if (option !== selectedOption) {
            setSelectedOption(option);
            toggleShowOptions(!showOptions);
            if (typeof onSelect === 'function') {
                onSelect(option);
            }
        }
    };
    var onSelectClick = function () {
        if (!passive && !clickRef.current) {
            toggleShowOptions(!showOptions);
            clickRef.current = true;
            setTimeout(function () {
                clickRef.current = false;
            }, 150);
        }
    };
    var handleOnBlur = function () {
        toggleShowOptions(false);
    };
    var handleOnKeyPress = function (e) {
        if (scroll) {
            var options_1 = document.querySelectorAll("[name=" + name + "] .ty-select-option");
            var scrollPos_1 = -1;
            options_1.forEach(function (option) {
                if (option.innerText.split(' ')[0].toLowerCase().startsWith(e.key.toLowerCase()) && scrollPos_1 === -1) {
                    scrollPos_1 = option.offsetTop;
                }
            });
            optionsRef.current.scrollTop = scrollPos_1;
        }
    };
    React.useEffect(function () {
        setSelectedOption(defaultOption);
    }, [options]);
    return (React.createElement(inputWrapper_1.InputWrapper, { passive: passive, type: _type, message: _message, label: label, size: size, onlyChildren: onlyChildren },
        React.createElement(clickOutside_1.ClickOutside, { onClickOutside: function () { return toggleShowOptions(false); }, condition: !passive },
            React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, position: "ty-relative" /* Relative */, backgroundColor: "ty-bg-beige" /* Beige */, className: selectboxClassName, onClick: onSelectClick, onFocus: onSelectClick, onBlur: handleOnBlur, onKeyPress: handleOnKeyPress, name: name, tabIndex: "-1" },
                React.createElement(text_1.Text, { color: "ty-color-dark-gray" /* DarkGray */ }, selectedOption ? (_j = selectedOption.selectedText, (_j !== null && _j !== void 0 ? _j : selectedOption.visual)) : placeholder),
                React.createElement(arrow_1.Arrow, { direction: "down" /* Down */, size: size }),
                React.createElement(styledLayout_1.StyledLayout, { forwardedRef: optionsRef, position: "ty-absolute" /* Absolute */, display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-column" /* Column */, className: optionsWrapperClassName, tabIndex: passive ? '-1' : '0' }, options.map(function (option, index) {
                    var key = "select-option-" + label + "-" + index;
                    return (React.createElement("div", { className: "ty-select-option", key: key, onClick: function () { return onOptionClick(option); } }, option.visual));
                }))))));
});
